import ko from '@tko/build.knockout';
import _ from 'lodash';
import $ from 'jquery';
import Signals from 'signals';
import DragDropGridService from './dragdrop-grid.service';
import '../../modules/assurance/components/panel/panel'; // TODO: Genericize; not an assurance-only component
import '../../app/bindings/ko-bindinghandler-domElement';
import templateMarkup from 'raw-loader!./dragdrop-grid.template.html';
import DataProvider from "../../app/data-framework/data-provider";
import {GridStack} from 'gridstack';
import 'gridstack/dist/h5/gridstack-dd-native';

class PanelDragDropGrid {
    constructor(params) {
        var self = this;
        self.subscriptions = [];

        self.gridstackclass = ko
            .observable('grid-stack grid-stack-4')
            .extend({ notify: 'always' });

        self.panelsOA = ko.observableArray([]);
        self.renderedItems = ko.observable({});
        self.dataProvider = DataProvider.getInstance();
        self.dashboardsAndTabsList = params.dashboardsAndTabsList;
        self.selectedTab = params.selectedTab;

        self.dashboardParams = ko.pureComputed(function () {
            return ko.unwrap(_.get(params, 'dashboard'));
        });

        self.appId = ko.unwrap(params.appId);
        self.viewId = ko.unwrap(params.viewId);
        self.disableDrag = params.disableDrag;

        self.afterAddWidget = function(domElements, itemData) {
            var item = _.find(domElements, ['nodeType', 1]);
            self.grid.makeWidget(item);

            ko.utils.domNodeDisposal.addDisposeCallback(item, function () {
                self.grid.removeWidget(item, false);
            });
        };

        self.subscribeDashboard();
    }

    initialize(params) {
        var self = this;

        self.dateRange = params.dateRange;
        self.panelsOA2 = params.panelsOA;

        self.panelDeletedSignal = _.get(params, 'signals.panelDeleted');
        self.resizeSignal = _.get(params, 'signals.resizeSignal');
        self.panelOptionsUpdatedSignal = _.get(params, 'signals.panelOptionsUpdated');
        self.panelPositionsUpdatedSignal = _.get(params, 'signals.panelPositionsUpdated');
        self.clonePanelSignal = _.get(params, 'signals.clonePanel');
        self.movePanelSignal = _.get(params, 'signals.movePanel');
        self.copyPanelSignal = _.get(params, 'signals.copyPanel');
        self.copyPanelAdvancedSignal = _.get(params, 'signals.copyPanelAdvanced');

        self.reflowSignal = new Signals.Signal();

        self.currentPanelList = [];
        self.originalPanelPositions = {};

        self.windowWidth = $(window).width();
        self.smWidth = 768;
        self.isFourColumnGrid = willFourColumnsFit(self.windowWidth);
        self.isInitialLoad = true;

        self.subscriptions.push(
            self.gridstackclass.subscribe(self.dispatchReflowSignal, self)
        );
        self.subscribePanel();

        $(window).on('resize', _.debounce(self.onWindowResize.bind(self), 100));

        self.setPanels();
        
        self.grid = GridStack.init({
            auto: false,
            cellHeight: 70,
            column: 4,
            margin: 0,
            handle: '.box-header',
            disableDrag: self.disableDrag()
        });
        self.grid.enableMove(!self.disableDrag(), true);
        self.subscriptions.push(
          self.disableDrag.subscribe((value) => {
              self.grid.enableMove(value, true);
          })
        );
        self.grid.column(getMaxCols());
        self.grid.on('dragstop', function(event, el) {
        var updatedPanels = DragDropGridService.getNodePositionsDiff(self.dragstartNodes, event.currentTarget, event.target);
        if (!_.isEmpty(updatedPanels)) {
          self.panelPositionsUpdatedSignal.dispatch(updatedPanels);
        }
        self.dragstartNodes = [];
        });
        
        self.grid.on('dragstart', function(event, el) {
        self.dragstartNodes = DragDropGridService.getNodePositions();
        });
    }

    unsubscribePanel() {
        var self = this;
        self.panelSubscripion.dispose();
        self.subscriptions.splice( self.subscriptions.indexOf(self.panelSubscripion), 1 );
    }

    subscribePanel() {
        var self = this;
        self.panelSubscripion = self.panelsOA2.subscribe(self.onPanelsChanged, self);
        self.subscriptions.push(self.panelSubscripion);
    }

    unsubscribeDashboard() {
        var self = this;
        self.dashboardSubsription.dispose();
        self.subscriptions.splice( self.subscriptions.indexOf(self.dashboardSubsription), 1 );
    }

    subscribeDashboard() {
        var self = this;
        self.dashboardSubsription = self.dashboardParams.subscribe(self.initialize.bind(self));
        self.subscriptions.push(self.dashboardSubsription);
    }

    onPanelsChanged() {
        var self = this;
        self.isInitialLoad = true;
        self.setOriginalPanelPositions(ko.unwrap(self.panelsOA2));
        self.setPanels();
        self.isInitialLoad = false;
    }

    setOriginalPanelPositions(panels) {
        var self = this;
        self.originalPanelPositions = {};
        _.forEach(panels, function (panel) {
            self.originalPanelPositions[panel.id] = { x: panel.x, y: panel.y };
        });
    }

    setPanels() {
        var self = this;
        var panels = ko.unwrap(self.panelsOA2);

        self.setGridStackClass();

        if (!_.isEmpty(panels)) {
            panels.sort(sortPanelByPosition);
            if (self.isInitialLoad && _.isEmpty(self.originalPanelPositions)) {
                self.setOriginalPanelPositions(panels);
            }
            panels = self.alignPanels(panels);
        }

        _.forEach(panels, function (panel) {
            if (!panel.params) {
                panel.params = {};
            }
            panel.params.signals = ko.observable({
                panelDeleted: self.panelDeletedSignal,
                panelOptionsUpdated: self.panelOptionsUpdatedSignal,
                reflowSignal: self.reflowSignal,
                resizeSignal: self.resizeSignal,
                clonePanel: self.clonePanelSignal,
                movePanel: self.movePanelSignal,
                copyPanel: self.copyPanelSignal,
                copyPanelAdvanced: self.copyPanelAdvancedSignal,
            });
            _.set(panel, 'params.dateRange', self.dateRange);
        });

        self.panelsOA(panels);
    }

    alignPanels(panels) {
        var self = this;

        return _.map(panels, function (panel) {
            return self.isInitialLoad || self.renderedItems()[panel.id]
                ? fixPanelPosition(panel)
                : _.assign(panel, { x: 0, y: 0 });
        });
    }

    dispatchReflowSignal(delay) {
        var self = this;
        self.reflowSignal.dispatch(delay /*delay to reflow*/);
    }

    loadOriginalPanelPositions() {
        var self = this;

        _.forEach(ko.unwrap(self.panelsOA), function (panel) {
            var originalPosition = self.originalPanelPositions[panel.id];
            if (originalPosition) {
                _.assign(panel, originalPosition);
            }
        });
    }

    onWindowResize() {
        var self = this;
        var newWidth = $(window).width();
        var canShowFourColumns = willFourColumnsFit(newWidth);
        var previousWidth = self.windowWidth;
        if (canShowFourColumns !== self.isFourColumnGrid) {
            self.setGridStackClass();

            if (canShowFourColumns && !_.isEmpty(self.originalPanelPositions)) {
                self.resizeflag = true;
                self.loadOriginalPanelPositions();
            }
            self.resizeGrid();
            self.resizeflag = false;
        }

        self.windowWidth = newWidth;
        self.isFourColumnGrid = canShowFourColumns;

        if (mobileBreakpointReached(previousWidth, newWidth, self.smWidth)) {
            self.setGridStackClass();
        }
    }

    resizeGrid() {
        var self = this;
        // TODO: Is there a better way to get the gridstack el? Will we ever have multiple '.grid-stack' els on the page?
        let gridStackEl = document.querySelector('.grid-stack');
        if (gridStackEl) {
          var gridStack = gridStackEl.gridstack;
          if (gridStack != null) {
            if (gridStack.getColumn() !== 1) {
              // gridstack has a built-in 1 column mode, and when the grid exits 1 column mode, gridstack attempts to
              // reset the grid to the previous number of columns. There is a bug in gridstack that manifests when we
              // attempt to manually set the column number when exiting 1 column mode. This check avoids that bug.
              gridStack.column(getMaxCols());
            }
            _.forEach(ko.unwrap(self.panelsOA), function(panel) {
              var panelElement = self.renderedItems()[panel.id];
              panel = fixPanelPosition(panel);
              gridStack.update(panelElement, { x: panel.x, y: panel.y, w: panel.width, h: panel.height });
            });
          }
        }
    }

    setGridStackClass() {
        var self = this;
        self.gridstackclass('grid-stack grid-stack-' + getMaxCols(self.windowWidth < self.smWidth));
    }

    dispose() {
        var self = this;
        _.forEach(self.subscriptions, function (subscription) {
            subscription.dispose();
        });
    }
}

function fixPanelPosition(panel, maxCols) {
    maxCols = maxCols || getMaxCols();

    if (panel.x >= maxCols) {
        panel.x = panel.x - maxCols;
        panel.y = panel.y + panel.height;
    }

    if ((panel.x + panel.width) > maxCols) {
        panel.x = 0;
        panel.y = panel.y + panel.height;
    }

    return panel;
}

function getMaxCols(isMobile) {
    return !!isMobile /*isMobile is optional default to false*/ ? 1 : willFourColumnsFit() ? 4 : 2;
}

function mobileBreakpointReached(windowWidth, newWidth, smWidth) {
    return (windowWidth > smWidth && newWidth < smWidth) || (windowWidth < smWidth && newWidth > smWidth);
}

function sortPanelByPosition(a, b) {
    return (a.x === b.x) ? a.y - b.y : a.x - b.x;
}

function willFourColumnsFit(width) {
    return (width || $(window).width()) > 1177; // screen wider than 1177px can accommodate 4 columns of panels
}

ko.components.register('dragdrop-grid', { template: templateMarkup, viewModel: PanelDragDropGrid });
